import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import Button from "react-bootstrap/Button";

import "../../styles/fms.scss";
import {
  edit_patient_fms,
  load_fms_from_patient_id,
} from "../../actions/clinic_content";
import { checkAuthenticated } from "../../actions/auth";

const initialTests = {
  tibia_height: "",
  hand_length: "",
  // DEEP SQUAT
  deep_squat: 0,
  deep_squat_final_score: 0,
  deep_squat_comments: "",
  // HURDLE STEP
  hurdle_step_d: 0,
  hurdle_step_i: 0,
  hurdle_step_final_score: 0,
  hurdle_step_comments: "",
  // INLINE LUNGE
  inline_lunge_d: 0,
  inline_lunge_i: 0,
  inline_lunge_final_score: 0,
  inline_lunge_comments: "",
  // // INLINE LUNGE - Ankle Clearing
  ankle_clearing_pain_d: "negativo",
  ankle_clearing_pain_i: "negativo",
  ankle_clearing_mobility_d: "",
  ankle_clearing_mobility_i: "",
  ankle_clearing_mobility_final_score: 0,
  ankle_clearing_comments: "",
  // SHOULDER MOBILITY
  shoulder_mobility_d: 0,
  shoulder_mobility_i: 0,
  shoulder_mobility_final_score: 0,
  shoulder_mobility_comments: "",
  shoulder_clearing_d: "negativo",
  shoulder_clearing_i: "negativo",
  // ACTIVE STRAIGHT-LEG RAISE
  active_straight_leg_raise_d: 0,
  active_straight_leg_raise_i: 0,
  active_straight_leg_raise_final_score: 0,
  active_straight_leg_raise_comments: "",
  // TRUNK STABILITY PUSHUP
  trunk_stability_pushup: 0,
  trunk_stability_pushup_final_score: 0,
  trunk_stability_pushup_comments: "",
  extension_clearing: "negativo",
  // ROTARY STABILITY
  rotary_stability_d: 0,
  rotary_stability_i: 0,
  rotary_stability_final_score: 0,
  rotary_stability_comments: "",
  flexion_clearing: "negativo",
  // TOTAL SCORE
  total_screen_score: 0,
};

const calculateTotalScore = (tests) => {
  const finalScoreKeys = [
    "deep_squat_final_score",
    "hurdle_step_final_score",
    "inline_lunge_final_score",
    "ankle_clearing_mobility_final_score",
    "shoulder_mobility_final_score",
    "active_straight_leg_raise_final_score",
    "trunk_stability_pushup_final_score",
    "rotary_stability_final_score",
  ];

  const total = finalScoreKeys.reduce((sum, key) => sum + (parseInt(tests[key]) || 0), 0);
  return total;
};

const PatientFMSPage = () => {
  const dispatch = useDispatch();
  const { pacienteId } = useParams();
  const [isEditable, setIsEditable] = useState(false);

  const [personalData, setPersonalData] = useState({
    id: null,
    name: "Nombre",
    lastnames: "Ejemplo",
    phone: "",
    rut: "",
    age: null,
    email: null,
    sex: "",
    prevision: "",
    country: "",
  });
  const [testsData, setTestsData] = useState(initialTests);

  const fetchFMSData = async () => {
    dispatch(checkAuthenticated());

    await load_fms_from_patient_id(pacienteId).then((data) => {
      const { clinic_patient, ...restOfData } = data;
      setPersonalData(clinic_patient);
      setTestsData(restOfData);
    });
  };

  const handleChange = (e) => {
    let newValue = e.target.value;
    let testKey = e.target.name;
    if (e.target.type === "number" && newValue === "") {
      newValue = 0;
    }
    setTestsData((prevTests) => {
      const updatedTests = {
        ...prevTests,
        [testKey]: newValue,
      };

      if (testKey.includes("final_score")) {
        updatedTests.total_screen_score = calculateTotalScore(updatedTests);
      }

      return updatedTests;
    });
  };

  const handleSave = async () => {
    dispatch(checkAuthenticated());
    console.log(testsData);
    await edit_patient_fms(pacienteId, testsData);
    setIsEditable(false);
  };
  useEffect(() => {
    fetchFMSData();
  }, []);

  return (
    <div className="content">
      <div className="fms-page row">
        <div className="col-12 col-lg-3">
          <h1>FMS - Paciente: {pacienteId}</h1>
          <div className="input-group mb-3">
            <span className="input-group-text">Nombre</span>
            <input
              disabled
              type="text"
              className="form-control"
              value={`${personalData.name} ${personalData.lastnames}`}
            />
          </div>
          <div className="input-group mb-3">
            <span className="input-group-text">Edad</span>
            <input
              disabled
              type="text"
              className="form-control"
              value={personalData.age}
            />
          </div>
          <div className="input-group mb-3">
            <span className="input-group-text">Sexo</span>
            <input
              disabled
              type="text"
              className="form-control"
              value={personalData.sex}
            />
          </div>

          {/* Datos Fisicos */}
          <div className="form-check form-switch py-3 mx-3">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="switchCheckEdit"
              checked={isEditable}
              onChange={() => setIsEditable(!isEditable)}
            />
            <label className="form-check-label" htmlFor="switchCheckEdit">
              Editar FMS
            </label>
          </div>

          <div className="input-group mb-3">
            <span className="input-group-text">Altura de Tibia</span>
            <input
              disabled={!isEditable}
              onChange={(e) => handleChange(e)}
              value={testsData.tibia_height}
              name="tibia_height"
              type="text"
              className="form-control"
            />
          </div>
          <div className="input-group mb-3">
            <span className="input-group-text">Longitud Mano</span>
            <input
              disabled={!isEditable}
              onChange={(e) => handleChange(e)}
              value={testsData.hand_length}
              name="hand_length"
              type="text"
              className="form-control"
            />
          </div>
          <div className="d-grid gap-2">
            <Button
              variant="primary fw-bold"
              disabled={!isEditable}
              onClick={() => handleSave()}
            >
              Guardar Cambios
            </Button>
          </div>
        </div>
        <div className="col-12 col-lg-9">
          <table className="w-100 fms-table">
            <thead>
              <tr>
                <th colSpan={2}>PRUEBA</th>
                <th>PUNTUACION BRUTA</th>
                <th>PUNTUACION FINAL</th>
                <th>COMENTARIOS</th>
              </tr>
            </thead>
            <tbody>
              {/* Sentadilla profunda */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  colSpan={2}
                >
                  <span>Sentadilla Profunda</span>
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.deep_squat}
                    name="deep_squat"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.deep_squat_final_score}
                    name="deep_squat_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className=" border border-black border-2 ">
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.deep_squat_comments}
                    name="deep_squat_comments"
                    type="text"
                    className="form-control"
                  />
                </td>
              </tr>
              {/* Paso de valla */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  rowSpan={2}
                >
                  <span>Paso de valla</span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.hurdle_step_d}
                    name="hurdle_step_d"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.hurdle_step_final_score}
                    name="hurdle_step_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.hurdle_step_comments}
                    name="hurdle_step_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.hurdle_step_i}
                    name="hurdle_step_i"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
              </tr>
              {/* Estocada en linea */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  rowSpan={2}
                >
                  <span>Estocada en linea</span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.inline_lunge_d}
                    name="inline_lunge_d"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={4}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.inline_lunge_final_score}
                    name="inline_lunge_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.inline_lunge_comments}
                    name="inline_lunge_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.inline_lunge_i}
                    name="inline_lunge_i"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 text-end px-2 "
                  rowSpan={2}
                >
                  <span className="fw-bold text-saudeki-primary">
                    DESCARTE DE TOBILLO - DOLOR
                    <br />
                    +/-
                  </span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  {/* <input 
                    disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_pain_d}
                    name="ankle_clearing_pain_d"
                    className={`form-select selected-${testsData.ankle_clearing_pain_d}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
                <td className="border border-black border-2 " rowSpan={4}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_comments}
                    name="ankle_clearing_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  {/* <input 
              disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_pain_i}
                    name="ankle_clearing_pain_i"
                    className={`form-select selected-${testsData.ankle_clearing_pain_i}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 text-end px-2 "
                  rowSpan={2}
                >
                  <span className="fw-bold text-saudeki-primary">
                    DESCARTE DE TOBILLO - MOVILIDAD
                    <br />
                    R-A-V
                  </span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_mobility_d}
                    name="ankle_clearing_mobility_d"
                    type="text"
                    className="form-control"
                    placeholder="Rojo/Amarillo/Verde"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_mobility_final_score}
                    name="ankle_clearing_mobility_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.ankle_clearing_mobility_i}
                    name="ankle_clearing_mobility_i"
                    type="text"
                    className="form-control"
                    placeholder="Rojo/Amarillo/Verde"
                  />
                </td>
              </tr>
              {/* Movilidad de hombro */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  rowSpan={2}
                >
                  <span>Movilidad de hombro</span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_mobility_d}
                    name="shoulder_mobility_d"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={4}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_mobility_final_score}
                    name="shoulder_mobility_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={4}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_mobility_comments}
                    name="shoulder_mobility_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_mobility_i}
                    name="shoulder_mobility_i"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 text-end px-2 "
                  rowSpan={2}
                >
                  <span className="fw-bold text-saudeki-primary">
                    DESCARTE DE HOMBRO
                    <br />
                    +/-
                  </span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  {/* <input 
              disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_clearing_d}
                    name="shoulder_clearing_d"
                    className={`form-select selected-${testsData.shoulder_clearing_d}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  {/* <input
                    
              disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.shoulder_clearing_i}
                    name="shoulder_clearing_i"
                    className={`form-select selected-${testsData.shoulder_clearing_i}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
              </tr>
              {/* Elevacion activa de pierna recta */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  rowSpan={2}
                >
                  <span>Elevacion activa de pierna recta</span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.active_straight_leg_raise_d}
                    name="active_straight_leg_raise_d"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.active_straight_leg_raise_final_score}
                    name="active_straight_leg_raise_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.active_straight_leg_raise_comments}
                    name="active_straight_leg_raise_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.active_straight_leg_raise_i}
                    name="active_straight_leg_raise_i"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
              </tr>
              {/* Estabilidad de tronco en flexion */}

              <tr>
                <td className="fw-bold border border-black border-2 px-2 ">
                  <span>Estabilidad de tronco en flexion</span>
                </td>
                <td className="border border-black border-2 "></td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.trunk_stability_pushup}
                    name="trunk_stability_pushup"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.trunk_stability_pushup_final_score}
                    name="trunk_stability_pushup_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={2}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.trunk_stability_pushup_comments}
                    name="trunk_stability_pushup_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 text-end px-2 "
                  colSpan={2}
                >
                  <span className="fw-bold text-saudeki-primary">
                    DESCARTE DE EXTENSIÓN +/-
                  </span>
                </td>
                <td className="border border-black border-2 ">
                  {/* <input 
                    disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.extension_clearing}
                    name="extension_clearing"
                    className={`form-select selected-${testsData.extension_clearing}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
              </tr>
              {/* Estabilidad Rotatoria */}
              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  rowSpan={2}
                >
                  <span>Estabilidad Rotatoria</span>
                </td>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  D
                </td>

                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.rotary_stability_d}
                    name="rotary_stability_d"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={3}>
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.rotary_stability_final_score}
                    name="rotary_stability_final_score"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control rowspan-input"
                  />
                </td>
                <td className="border border-black border-2 " rowSpan={3}>
                  <textarea
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.rotary_stability_comments}
                    name="rotary_stability_comments"
                    type="text"
                    className="form-control rowspan-input"
                  />
                </td>
              </tr>
              <tr>
                <td className="px-3 border border-black border-2 text-center fw-bold text-saudeki-primary">
                  I
                </td>
                <td className="border border-black border-2 ">
                  <input
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.rotary_stability_i}
                    name="rotary_stability_i"
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  />
                </td>
              </tr>

              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 text-end px-2"
                  colSpan={2}
                >
                  <span className="fw-bold text-saudeki-primary">
                    DESCARTE DE FLEXIÓN +/-
                  </span>
                </td>
                <td className="border border-black border-2 ">
                  {/* <input 
              disabled={!isEditable}
                    type="number"
                    min={0}
                    max={3}
                    className="form-control"
                  /> */}
                  <select
                    disabled={!isEditable}
                    onChange={(e) => handleChange(e)}
                    value={testsData.flexion_clearing}
                    name="flexion_clearing"
                    className={`form-select selected-${testsData.flexion_clearing}`}
                    aria-label="Default select example"
                  >
                    <option className="opcion-negativo" value="negativo">
                      Negativo (-)
                    </option>
                    <option className="opcion-positivo" value="positivo">
                      Positivo (+)
                    </option>
                  </select>
                </td>
              </tr>
              {/* Puntuacion total */}

              <tr>
                <td
                  className="fw-bold border border-black border-2 px-2 "
                  colSpan={2}
                >
                  <span>Puntuación Total</span>
                </td>
                <td className="border border-black border-2 " colSpan={3}>
                  <input
                    disabled
                    // disabled={!isEditable}
                    // onChange={(e) => handleChange(e)}
                    value={testsData.total_screen_score}
                    name="total_screen_score"
                    type="number"
                    min={0}
                    className="w-100 form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PatientFMSPage;
